import { useMemo } from 'react';

import { ArrowDown02Icon, ArrowTurnBackwardIcon, ArrowUp02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Trans } from 'react-i18next';

import { FieldTypes } from '../constants/field-types-enum';

export const useKeyboardHints = fieldType => {
  const keyboardHint = useMemo(() => {
    switch (fieldType) {
      case FieldTypes.FreeText:
      case FieldTypes.Statement:
        return (
          <span className="d-flex align-items-center text-tertiary u-font-size-x-small u-font-weight-500 sm-hide white-space-pre-wrap">
            <Trans
              i18nKey="keyboard.hint.pressShiftEnter"
              components={[
                <HugeiconsIcon size="12" icon={ArrowUp02Icon} strokeWidth="3" />,
                <HugeiconsIcon size="12" icon={ArrowTurnBackwardIcon} strokeWidth="3" />,
              ]}
            />
          </span>
        );
      case FieldTypes.MultipleChoice:
      case FieldTypes.OpinionScale:
      case FieldTypes.StarRating:
      case FieldTypes.Upload:
      case FieldTypes.Signature:
      case FieldTypes.Checkbox:
        return (
          <span className="d-flex align-items-center text-tertiary u-font-size-x-small u-font-weight-500 sm-hide">
            Tab and Space
            <div className="spacebar-icon u-margin-x--small"></div>
            to select
          </span>
        );
      case FieldTypes.YesNo:
        return (
          <span className="d-flex align-items-center text-tertiary u-font-size-x-small u-font-weight-500 sm-hide">
            Press Tab and{' '}
            <div className="u-margin-x--small u-border u-border-radius--xs-small u-padding-x--small">
              Y
            </div>{' '}
            or{' '}
            <div className="u-margin-x--small u-border u-border-radius--xs-small u-padding-x--small">
              N
            </div>{' '}
            to select
          </span>
        );
      case FieldTypes.Select:
        return (
          <span className="d-flex align-items-center text-tertiary u-font-size-x-small u-font-weight-500 sm-hide">
            <Trans
              i18nKey="keyboard.hint.Select"
              components={[
                <HugeiconsIcon size="12" icon={ArrowUp02Icon} strokeWidth="3" />,
                <HugeiconsIcon size="12" icon={ArrowDown02Icon} strokeWidth="3" />,
              ]}
            />
          </span>
        );
      default:
        return null;
    }
  }, [fieldType]);

  return keyboardHint;
};
